<!-- ══════════════════════════════════════════════════════════════════════════
     NUEVA VERSIÓN DE CONDICIONES COMERCIALES — el cascarón de la ruta.

     🔴 2026-09-28 (CONTRATO-REDISENO-ALTAS.md, «C»): el formulario pasó a
     `app-condiciones-pasos`, por pasos (Plazo y comisión · Cobros · Modelos ·
     Riesgo y liquidación · Revisar). Acá queda la miga, el título, qué rige hoy
     y la creación de la versión. «Lo que rige hoy» dejó de ser una tarjeta: es
     el renglón de datos del título, y cada paso dice lo que rige de lo suyo.

     `kb-gateway`: es una ruta propia a pantalla completa (fuera del
     `<router-outlet>` de la ficha del comercio), así que no hereda el
     `.kb-gateway` que pone los botones en negro. Se pone acá.
     ══════════════════════════════════════════════════════════════════════════ -->
<div class="kb-gateway" [class.kb-page]="standalone">

  <nav class="kb-migas" aria-label="Ubicación" *ngIf="standalone">
    <a class="kb-miga" [routerLink]="['/console/merchants']">Comercios</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <a class="kb-miga" [routerLink]="['/console/merchants', codigo]">{{ comercio?.name || codigo }}</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <a class="kb-miga" [routerLink]="['/console/merchants', codigo, 'condiciones']">Condiciones</a>
    <span class="kb-miga-sep" aria-hidden="true"><i class="fas fa-chevron-right"></i></span>
    <span class="kb-miga-actual">Nueva versión</span>
  </nav>

  <div *ngIf="loading" class="space-y-[32px]" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-9 w-1/3"></div>
    <div class="kb-skeleton h-12 w-full"></div>
    <div class="space-y-[16px]">
      <div class="kb-skeleton h-10 w-full max-w-xl" *ngFor="let s of [1,2,3]"></div>
    </div>
  </div>

  <div class="kb-empty" *ngIf="!loading && noEncontrado">
    <span class="kb-empty-icono"><i class="fas fa-file-contract" aria-hidden="true"></i></span>
    <p class="kb-empty-titulo">No encontramos el comercio «{{ codigo }}»</p>
  </div>

  <ng-container *ngIf="!loading && !noEncontrado">

    <div class="kb-ficha" *ngIf="standalone">
      <div class="min-w-0">
        <h1 class="kb-ficha-titulo">Nueva versión de condiciones</h1>
        <p class="kb-ficha-meta">
          <span class="truncate">{{ comercio?.name || codigo }}</span>
          <span aria-hidden="true">·</span>
          <span>versión número <span class="tabular-nums">{{ proximoNumero }}</span></span>
          <ng-container *ngIf="vigente">
            <span aria-hidden="true">·</span>
            <span>reemplaza a <span class="font-mono">{{ vigente.version.code }}</span>, que rige desde el
              <span class="tabular-nums">{{ vigente.version.date_init | date:'dd/MM/yyyy' }}</span>
              y se cierra el día en que empiece la nueva</span>
          </ng-container>
        </p>
      </div>
    </div>

    <!-- Una sola cinta, y sólo cuando es la primera versión de un comercio real. -->
    <div class="kb-aviso kb-aviso-info mb-[24px]" *ngIf="standalone && !vigente && !esPropuesta">
      <i class="fas fa-info-circle mt-0.5" aria-hidden="true"></i>
      <p class="m-0">
        <strong class="font-semibold">Es la primera versión de este comercio.</strong>
        Hasta que exista una comisión vigente y aprobada, no se le puede facturar.
      </p>
    </div>

    <app-condiciones-pasos
        [modo]="modo" [comercio]="comercio"
        [vigente]="esPropuesta ? null : vigente" [semilla]="esPropuesta ? vigente : null"
        [proximoNumero]="proximoNumero" [pasoInicial]="pasoInicial"
        [guardando]="guardando" [error]="error"
        [claveBorrador]="esPropuesta ? null : 'version:' + codigo"
        (guardado)="crear($event)" (cancelado)="volver()">
    </app-condiciones-pasos>

  </ng-container>
</div>
